import React, { useState, useEffect, useRef } from 'react'
import Grid from '@mui/material/Grid2'
import { Container, CardMedia } from '@mui/material'
import { useNavigate } from "react-router-dom";
import AtomLink from '../../atoms/link/link'
import AtomButton from '../../atoms/button'
import { Link } from "react-router-dom";
import { CirclePatternTop, Event1, Event2, Event3, Event4, Event5, Event6, DialogArrow, ChevronRight } from '../../helpers/constant/imageUrl'
import './newsEvent.scss'
import getNewsFromFirebase, { NewsItem } from "../../services/newsService";
import DOMPurify from "dompurify";
import { DocumentSnapshot } from 'firebase/firestore';
import LatestNews from '../home/LatestNews';
import Loader from '../../Component/Loader';

interface NewsEventProps {
    limit?: number;
}

const NewsEventTemplate: React.FC<NewsEventProps> = ({ limit = 6 }) => {
    const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [lastNewsItem,setLastNewsItems] = useState<DocumentSnapshot | null>()
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = useState(0)
    const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
        setCurrentTab(newValue)
    }
    useEffect(() => {
        const fetchAllNews = async () => {
            try {
                setLoading(true);
                const {news:allNewsData, lastVisible} = await getNewsFromFirebase(6);
                setLastNewsItems(lastNewsItem)
                if(allNewsData?.length < 6){
                    setHasMore(false);
                }
                setNewsItems(allNewsData);
                setError(null);
            } catch (err) {
                console.error("Error fetching all news:", err);
                setError("Failed to load news. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchAllNews();
    }, []);

    const [hasMore, setHasMore] = useState(true);
        const isFetchingRef = useRef(false);
    
    async function getNextNews() {
      if (isFetchingRef.current || !hasMore) return;
      isFetchingRef.current = true;
      setLoading(true);
    
      try {
         
        const lastItemId = newsItems[newsItems.length - 1];
        const {news:nextNews,lastVisible} = await getNewsFromFirebase(6, lastNewsItem);
        setLastNewsItems(lastVisible);
    
        if (nextNews.length === 0) {
          setHasMore(false);
        } else {
          setNewsItems((prevNews) => [...prevNews, ...nextNews]);
        }
      } catch (err) {
        console.error("Error fetching more blogs", err);
        setError("Failed to load more blogs.");
      } finally {
        setLoading(false);
        isFetchingRef.current = false;
      }
    }
    

    return (
        <div className="news-events">
            <div className='gradient-section'>
                <div className='pattern-top'>
                    <img src={CirclePatternTop} alt='CirclePatternTop' />
                </div>
                <div className='pattern-bottom'>
                    <img src={CirclePatternTop} alt='CirclePatternTop' />
                </div>
                <Container className='container'>
                    <h1>News & Events</h1>
                    <p>Stay updated with the latest news and media coverage on Kumar Organic Products Limited. Explore our recent events, innovations, and industry insights here.</p>
                </Container>
            </div>

            <div className='all-updates'>
                <Container className='container'>
                    <Grid container rowSpacing={{ xs: 1, sm: 2, md: 6 }} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        {newsItems.map((item) => {
                        //      const sanitizedDescription = DOMPurify.sanitize(item.description || "");
                        //     const shortDescription = sanitizedDescription.length > 120
                        // ? `${sanitizedDescription.substring(0, 120)}...`
                        // : sanitizedDescription;
                        const sanitizedShortDes = DOMPurify.sanitize(item.shortdescription || "");
                        console.log('News item:', item);

                        console.log('Short Description:', sanitizedShortDes);

                        return (

                            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <div className='card'>
                                <img src={item.thumbnailImage} alt='thumb' className='thumb' />
                                
                                <div className='pl-4 pr-4'>
                                    <div className='title'>
                                        {item.title}
                                    </div>
                                    <div className='white-section'>
                                        <h5>{item.heading}</h5>
                                        <p dangerouslySetInnerHTML={{__html:sanitizedShortDes}}/> 
                                        <AtomLink
                                            href={`/news/${item.id}`}
                                            className='read-article'
                                            startIcon={<img src={DialogArrow} alt='DialogArrow' />}
                                        >
                                            Read Article
                                        </AtomLink>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        );
                    })}

                      {loading && <Loader/>}
                    </Grid>
                    {hasMore && <div className='text-center mt-16' >
                        <AtomButton
                            onClick={getNextNews}
                            variant={'outlined'}
                            size={'large'}
                            endIcon={
                                <img src={ChevronRight} alt='ChevronRight' />
                            }
                        >
                            VIEW MORE
                        </AtomButton>
                    </div>}
                </Container>
            </div>
        </div>
    )
}

export default NewsEventTemplate